export default {
    title_list: 'Companies',
    title_page: 'Company',
    title_create_page: 'Create a company',
    title_edit_page: 'Change company',

    filter: {
        labels: {
            company_name: 'Company name',
        }
    },

    table: {
        labels: {
            id: 'ID',
            company_name: 'Company name',
            email: 'Email',
            industry: 'Industry',
        }
    },

    buttons: {

    },

    labels: {
        drag_in_drop: 'Drag or click to select files',
    },

    form: {
        user_id: 'Member',
        company_name: 'Company name',
        logo: 'Logo',
        url: 'Website',
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email',
        email_subscription: 'Email subscription',
        industry_id: 'Industry',
    },
}
